const columns = [
    {
        title: 'Account No.',
        dataIndex: 'login',
    },
    {
        title: 'Account Type',
        dataIndex: 'acType',
    },
    {
        title: 'Balance',
        dataIndex: 'balance',
        render: (balance) => `$ ${balance.toFixed(2)}`,
    },
];

export default columns;